<ng-container [formGroup]="formGroupCampaignTypeData">
    <mdb-form-control class="form-fill" >
        <app-mdbp-input mdbInput formControlName="goal" [isCurrencyMask]="true" label='Optional Campaign Goal'>
            <input  #inputNameC currencyMask formControlName="goal"  class="form-control form-control--paybee"/>
        </app-mdbp-input>
    </mdb-form-control>
</ng-container>